import type {ScreenOrientation, Size2D} from '@gongxigames/framework/core/types';
import type {GameProvider} from './GameProvider';
import type {Rectangle} from 'pixi.js';

export type AreaSizeByOrientation = {
    [ScreenOrientation.LANDSCAPE]: Size2D;
    [ScreenOrientation.PORTRAIT]: Size2D;
};

export type GameBoundingBoxByOrientation = {
    [ScreenOrientation.LANDSCAPE]: Rectangle;
    [ScreenOrientation.PORTRAIT]: Rectangle;
};

export type UIZoneConfig = {
    uiAreaSize: AreaSizeByOrientation;
    gameWindow: GameBoundingBoxByOrientation;
};

export type UILayout = UIZoneConfig & {
    name: string;
    resourcesPackage: string;
    gameProvider: GameProvider;
};
